// extracted by mini-css-extract-plugin
module.exports = {"doctorCard":"DoctorCard_doctorCard__V9pcg"};